import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import "./style.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MenuIcon from "@mui/icons-material/Menu";
import userIcon from "assests/user-icon.png";
import { useSelector } from "react-redux";

const ContentHeaderContainer = ({
  title,
  backButton,
  handleBack,
  subtitle,
  isMobile,
  handleDrawerToggle, 
}) => {
  const userData = useSelector((state) => state?.posData);
  return (
    <Box className="main-content-header">
      <Box className="content-header-container d-flex align-items-center justify-content-between">
        <Box className="d-flex align-items-center">
          {/* Hamburger Icon for Mobile */}
          {isMobile && (
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
              aria-label="open drawer"
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Optional back button */}
          {backButton && (
            <IconButton
              edge="start"
              onClick={handleBack}
              aria-label="back"
              sx={{ mr: 3 }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}

          {/* Page Title / Subtitle */}
          <Box className="d-flex direction-column">
            <Typography variant="h3" sx={{ fontSize: "24px", fontWeight: "600" }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography
                variant="h6"
                sx={{ fontSize: "14px", fontWeight: "400", color: "#6B7280", mt: 1 }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>

        {/* User info / Profile section on the right */}
        <Box className="d-flex justify-content-end align-items-center">
          <Box className="dropdown">
            <Box
              id="dropdownMenuButton"
              style={{
                border: "none",
                padding: "0px",
                display: "flex",
                alignItems: "center",
                background: "none",
              }}
            >
              <Box className="dropdown-profile-conatiner">
                <img src={userIcon} alt="icon" />
              </Box>
              <Box className="user-data">
                <Typography variant="subtitle1" className="user-name">
                  {userData ? `${userData?.first_name} ${userData?.last_name} `: "Admin"}
                </Typography>
                <Typography variant="subtitle2">
                  {userData?.email ? userData?.email : "admin@gmail.com"}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContentHeaderContainer;
